import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';

import useAuthContext from 'contexts/AuthProvider/useAuthContext';
import InitializeMatrix from 'contexts/MatrixContext/InitializeMatrix';
import useMxCookies from 'modules/Authentication/hooks/useMxCookies';
import { useIsRoomRoute } from 'routes/hooks/useIsRoomRoute';
import { isGuestModeEnabled } from 'utils/utils';

const ProtectedRoute = () => {
  const { authPageVisited, isContinueAsGuest } = useAuthContext();
  const { mxLoggedIn } = useMxCookies();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const loginToken = searchParams.get('loginToken');
  const isInAuthPage = location.pathname === '/auth';
  const isRoomRoute = useIsRoomRoute();

  const guestModeEnabled = isGuestModeEnabled();
  const shouldShowAuthPage =
    !mxLoggedIn && !authPageVisited && !isContinueAsGuest && (!isRoomRoute || !guestModeEnabled) && !loginToken;
  const isAuthChoiceNeeded = isInAuthPage && !isContinueAsGuest;

  if (shouldShowAuthPage || isAuthChoiceNeeded) {
    if (isInAuthPage) return <Outlet />;

    return <Navigate to="/auth" replace state={{ authFrom: location.pathname }} />;
  }

  return (
    <InitializeMatrix>
      <Outlet />
    </InitializeMatrix>
  );
};

export default ProtectedRoute;
